export default __webpack_public_path__ + "static/media/clapped.a90baf01.svg";